export default {
    name: 'Master-Operation',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
